import React from 'react';
import PropTypes from 'prop-types';
import ImageViewer from './src/ImageViewer';
import { showScroll, hideScroll, getBit } from '../../../helpers/utils';
import {
    PDF_CONTENT_TYPE,
    JPEG_CONTENT_TYPE,
    PNG_CONTENT_TYPE,
    BMP_CONTENT_TYPE,
    WEBP_CONTENT_TYPE,
    GIF_CONTENT_TYPE,
} from '../../../helpers/constants';

import store from '../../../stores/store';
import FullComposition from './FullComposition';

export default class DocumentViewerModal extends React.Component {
    componentDidMount() {
        hideScroll();
    }

    componentWillUnmount() {
        showScroll();
    }

    canCreateNotes(permissions) {
        return getBit(1, permissions);
    }

    canPrint(permissions) {
        return (permissions & 4) === 4
    }

    canEmail(permissions) {
        return (permissions & 8) === 8
    }

    canDownload(permissions) {
        return getBit(3, permissions);
    }

    onClickPrevious = item => {
        // console.log('DocumentViewerModal onClickPrevious', item);
        store.documents.fetchDocument({
            instanceId: item.instanceId,
            docTypeId: item.docTypeId,
            docId: item.docId,
            DocExtension: item.extension,
            DocPermissions: item.permissions,
            DocName: item.fileName,
            fromHistory: true,
        });
    };

    onClickGovernance = item => {
        if (store.documents.currentDocument.onClose) store.documents.currentDocument.onClose('2');
        if (this.props.onClose) this.props.onClose(item);
    };

    chooseRender = (contentType, permissions, blob, viewableDocumentBytes, fileName, onClose, annotations) => {
        // console.log('DocumentViewerModal chooseRender', blob)
        switch (contentType) {
            case PDF_CONTENT_TYPE:
                return (
                    <FullComposition
                        fileName={fileName}
                        blob={blob}
                        viewableDocumentBytes={viewableDocumentBytes}
                        className
                        showDownload={window.require && (this.canPrint(permissions) || this.canEmail(permissions))}
                        showNotes={this.canCreateNotes(permissions)}
                        onClose={onClose}
                        showRotation={true}
                        previousDocs={store.documents.getPreviousDocuments()}
                        onClickPrevious={this.onClickPrevious}
                        annotations={annotations}
                    />
                );
            // break;
            case JPEG_CONTENT_TYPE:
            case PNG_CONTENT_TYPE:
            case GIF_CONTENT_TYPE:
            case WEBP_CONTENT_TYPE:
            case BMP_CONTENT_TYPE:
                // console.log('image chooseRender');
                return (
                    <ImageViewer
                        blob={blob}
                        fileName={fileName}
                        onClose={onClose}
                        previousDocs={store.documents.getPreviousDocuments()}
                        onClickPrevious={this.onClickPrevious}
                    />
                );
            // break;
            default:
                return (
                    <div>
                        No viewer for this content-type:
                        {contentType}
                        <button onClick={onClose}>Close viewer</button>
                    </div>
                );
        }
    };

    render() {
        let { document, onClose /*, loading */ } = this.props;
        let { fileName, blob, viewableDocumentBytes, contentType, permissions, DocAnnotations } = document;
        // console.log('DocumentViewerModal render', document);
        return (
            <div className="document-modal-wrapper">
                {!blob ? (
                    <div>There is nothing to show</div>
                ) : (
                        this.chooseRender(
                            contentType,
                            permissions,
                            blob,
                            viewableDocumentBytes,
                            fileName,
                            onClose,
                            DocAnnotations,
                        )
                    )}
            </div>
        );
    }
}

DocumentViewerModal.propTypes = {
    document: PropTypes.shape({
        fileName: PropTypes.string,
        blob: PropTypes.string,
        contentType: PropTypes.string,
        permissions: PropTypes.number,
        DocAnnotations: PropTypes.array,
    }),
    onClose: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/DocumentViewerModal.js